import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const links = [
  { label: 'Sobre mí',   target: 'sobre'       },
  { label: 'Cursos',     target: 'cursos'       },
  { label: 'Mentorías',  target: 'mentorias'    },
  { label: 'Testimonios',target: 'testimonios'  },
  { label: 'FAQ',        target: 'faq'          },
]

const NAVBAR_HEIGHT = 72

function scrollToSection(id) {
  const el = document.getElementById(id)
  if (!el) return

  const top =
    el.getBoundingClientRect().top +
    window.scrollY -
    NAVBAR_HEIGHT

  window.scrollTo({ top, behavior: 'smooth' })
}

export default function Navbar() {
  const [scrolled,  setScrolled]  = useState(false)
  const [menuOpen,  setMenuOpen]  = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Cierra el menú al rotar / redimensionar
  useEffect(() => {
    const onResize = () => { if (menuOpen) setMenuOpen(false) }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [menuOpen])

  const handleMobileNavigation = (target) => {
    // 1. Cierra el menú
    setMenuOpen(false)

    // 2. Espera que la animación de cierre termine (350 ms)
    //    antes de calcular la posición del elemento, ya que
    //    el menú abierto desplaza el layout y genera offsets erróneos.
    setTimeout(() => scrollToSection(target), 380)
  }

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0,   opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background:    scrolled ? 'rgba(13,13,13,0.96)' : 'transparent',
        backdropFilter:scrolled ? 'blur(24px)'           : 'none',
        borderBottom:  scrolled
          ? '1px solid rgba(201,168,76,0.14)'
          : '1px solid transparent',
        transition: 'background 0.4s, border-color 0.4s, backdrop-filter 0.4s',
      }}
    >
      <div className="flex items-center justify-between px-[5vw] h-[72px]">

        {/* LOGO */}
        <button
          onClick={() => scrollToSection('hero')}
          className="font-display font-black text-[12px] tracking-[0.12em] uppercase mb-1"
          style={{ color: 'var(--gold)' }}
        >
          Aprende Con Dante
        </button>

        {/* DESKTOP LINKS */}
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.target}
              onClick={() => scrollToSection(l.target)}
              className="font-body text-[13px] tracking-[0.04em] transition-colors duration-200"
              style={{ color: 'var(--ink-2)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--gold)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--ink-2)')}
            >
              {l.label}
            </button>
          ))}
        </div>

        {/* CTA + MOBILE */}
        <div className="flex items-center gap-4">

          {/* CTA DESKTOP */}
          <button
            onClick={() => scrollToSection('cursos')}
            className="hidden md:flex items-center gap-2 px-[22px] py-[10px] font-display font-bold text-[12px] tracking-[0.1em] uppercase transition-all duration-200"
            style={{ border: '1px solid var(--gold)', color: 'var(--gold)' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--gold)'
              e.currentTarget.style.color      = '#000'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent'
              e.currentTarget.style.color      = 'var(--gold)'
            }}
          >
            Ver cursos
          </button>

          {/* HAMBURGER MOBILE */}
          <button
            className="md:hidden flex flex-col gap-[5px] p-2"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Menu"
          >
            {[0, 1, 2].map((i) => (
              <motion.span
                key={i}
                className="block h-[1px] w-5"
                style={{ background: 'var(--gold)' }}
                animate={
                  menuOpen
                    ? i === 0 ? { rotate: 45,  y: 6  }
                    : i === 2 ? { rotate: -45, y: -6 }
                    :           { opacity: 0 }
                    : { rotate: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 0.25 }}
              />
            ))}
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden md:hidden"
            style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--line)' }}
          >
            <div className="flex flex-col px-[5vw] py-6 gap-5">

              {links.map((l) => (
                <button
                  key={l.target}
                  onClick={() => handleMobileNavigation(l.target)}
                  className="font-display font-semibold text-[14px] tracking-[0.08em] uppercase text-left"
                  style={{ color: 'var(--ink-2)' }}
                >
                  {l.label}
                </button>
              ))}

              <button
                onClick={() => handleMobileNavigation('cursos')}
                className="btn-fill self-start mt-2"
              >
                Ver cursos
              </button>

            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  )
}